import { Module, VuexModule, Mutation } from 'vuex-module-decorators';

@Module({name: 'ConfirmPopup', namespaced: true})
export default class ConfirmPopup extends VuexModule {
    public confirmPopupVisibility: boolean = false;
    public confirmAction: string = '';
    public confirmActionData: any = [];
    public confirmQuestionText: string = 'Please confirm your action';
    public confirmInfoText: string = '';
    public confirmButton: string = 'delete';
    public confirmIcon: string = '';
    public confirmHeaderText: string = '';
    public confirmButtonClass: string = 'hococo-register-form-btn';

    @Mutation
    public RESET_CONFIRM_POPUP_STORE_STATE() {
        this.confirmPopupVisibility = false;
        this.confirmAction          = '';
        this.confirmActionData      = [];
        this.confirmQuestionText    = 'Please confirm your action';
        this.confirmInfoText        = '';
        this.confirmButton          = 'delete';
        this.confirmIcon            = '';
        this.confirmHeaderText      = '';
        this.confirmButtonClass     = 'hococo-register-form-btn';
    }

    get getConfirmIcon() {
        return this.confirmIcon;
    }

    get getConfirmHeaderText() {
        return this.confirmHeaderText;
    }

    get getConfirmPopupVisibility() {
        return this.confirmPopupVisibility;
    }

    get getConfirmAction() {
        return this.confirmAction;
    }

    get getConfirmActionData() {
        return this.confirmActionData;
    }

    get getConfirmQuestionText() {
        return this.confirmQuestionText;
    }

    get getConfirmInfoText() {
        return this.confirmInfoText;
    }

    get getConfirmButton() {
        return this.confirmButton;
    }

    get getConfirmButtonClass(): string {
        return this.confirmButtonClass;
    }

    @Mutation
    public RESET_CONFIRM_POPUP_DATA() {
        this.confirmAction          = '';
        this.confirmActionData      = [];
        this.confirmQuestionText    = 'Please confirm your action';
        this.confirmInfoText        = '';
        this.confirmButton          = 'delete';
        this.confirmPopupVisibility = false;
        this.confirmButtonClass     = 'hococo-register-form-btn';
    }

    @Mutation
    public SET_CONFIRM_POPUP_DATA(data: any) {
        if (data.confirmAction) {
            this.confirmAction          = data.confirmAction ? data.confirmAction : this.confirmAction;
            this.confirmActionData      = data.confirmActionData ? data.confirmActionData : this.confirmActionData;
            this.confirmQuestionText    = data.confirmQuestionText ? data.confirmQuestionText : this.confirmQuestionText;
            this.confirmInfoText        = data.confirmInfoText ? data.confirmInfoText : this.confirmInfoText;
            this.confirmButton          = data.confirmButton ? data.confirmButton : this.confirmButton;
            this.confirmPopupVisibility = true;
            this.confirmIcon            = data.confirmIcon ? data.confirmIcon : '';
            this.confirmHeaderText      = data.confirmHeaderText ? data.confirmHeaderText : '';
            this.confirmButtonClass     = data.confirmButtonClass ? data.confirmButtonClass : 'hococo-register-form-btn';
        }
    }
}
